import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentUser on User {
    id
    lastName
    firstName
    email
    jobTitle
    employeeId
    isPlatformAdmin
    isTenant
    tags {
      value
      key
    }
    phoneNumber
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentUserFragment,
  Omit<ents.core.admin.User, 'cognitoId'>
>({
  email: transformers.PASS_THROUGH,
  employeeId: transformers.PASS_THROUGH,
  firstName: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.admin.User.Id.assertIsId,
    {
      warnOnly: true,
    },
  ),
  isPlatformAdmin: transformers.PASS_THROUGH,
  isTenant: transformers.PASS_THROUGH,
  jobTitle: transformers.PASS_THROUGH,
  lastName: transformers.PASS_THROUGH,
  name: ({ firstName, lastName }) =>
    firstName && lastName
      ? `${firstName} ${lastName}`
      : (firstName ?? lastName ?? 'Unknown User'),
  phoneNumber: transformers.PASS_THROUGH,
  tags: graphql.transformers.OUT.list(
    graphql.transformers.OUT.object({
      key: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
        {
          warnOnly: true,
        },
      ),
      value: transformers.PASS_THROUGH,
    }),
    {
      onNullish: 'remove',
    },
  ),
})
